/**
 * Class description
 *
 * Created: 2017-10-09
 * @author jonas
 */
import {
    ISymbolNewStateTransitionConfig,
    ISymbolOldStateTransitionConfig,
    ISymbolStateConfig,
    StateReelSymbol
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TeslaGameConfig} from "../TeslaGameConfig";
import {TeslaReels} from "./TeslaReels";
import {Timeline} from "gsap";

export class TeslaStateReelSymbol extends StateReelSymbol {


    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }

    protected initState(stateConfig:ISymbolStateConfig):boolean {
        return super.initState(stateConfig);
    }

    public changeState(newStateConfig:ISymbolNewStateTransitionConfig, oldStateConfig?:ISymbolOldStateTransitionConfig):Timeline | null {
        const anim:Timeline | null = super.changeState(newStateConfig, oldStateConfig);

        if(anim == null) {
            return null;
        }

        if(newStateConfig.state.keyword == TeslaGameConfig.instance.SYMBOL_STATES.win.keyword ||
            newStateConfig.state.keyword == TeslaGameConfig.instance.SYMBOL_STATES.attention.keyword) {
            TeslaReels.moveSymbolToTopLayer(this.reelId, this);
        } else {
            TeslaReels.moveSymbolToBottomLayer(this.reelId, this);
        }

        return anim;

    }
}